import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThresholdProvider } from "@/context/ThresholdContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Departments from "@/pages/Departments";
import Machines from "@/pages/Machines";
import Employees from "@/pages/Employees";
import Shifts from "@/pages/Shifts";
import Maintenance from "@/pages/Maintenance";
import CompletedProducts from "@/pages/CompletedProducts";
import Products from "@/pages/Products";
import Operations from "@/pages/Operations";
import ProductionEntry from "@/pages/ProductionEntry";
import Trends from "@/pages/Trends";
import Reports from "@/pages/Reports";
import AiAnalysis from "@/pages/AiAnalysis";
import Settings from "@/pages/Settings";

function Guard({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <ThresholdProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Guard><Layout /></Guard>}>
                <Route index element={<Dashboard />} />
                <Route path="bolumler" element={<AdminGuard><Departments /></AdminGuard>} />
                <Route path="makineler" element={<AdminGuard><Machines /></AdminGuard>} />
                <Route path="personel" element={<AdminGuard><Employees /></AdminGuard>} />
                <Route path="vardiyalar" element={<AdminGuard><Shifts /></AdminGuard>} />
                <Route path="urunler" element={<AdminGuard><Products /></AdminGuard>} />
                <Route path="operasyonlar" element={<AdminGuard><Operations /></AdminGuard>} />
                <Route path="uretim-girisi" element={<AdminGuard><ProductionEntry /></AdminGuard>} />
                <Route path="bakim" element={<AdminGuard><Maintenance /></AdminGuard>} />
                <Route path="tamamlanan-urunler" element={<CompletedProducts />} />
                <Route path="trendler" element={<Trends />} />
                <Route path="raporlar" element={<Reports />} />
                <Route path="ai-analiz" element={<AiAnalysis />} />
                <Route path="ayarlar" element={<AdminGuard><Settings /></AdminGuard>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ThresholdProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
